/*
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
 */
import { defineStore } from "pinia";
import workflowService from "../services/WorkflowService.js";

const POLLING_INTERVAL_MS = 5 * 60 * 1000;

let pollingIntervalId = null;

export const useTaskNotificationStore = defineStore({
  id: "TaskNotificationStore",
  state: () => ({
    hasActiveTasks: false,
  }),
  actions: {
    async checkTasks() {
      try {
        const tasksList = await workflowService.listTasks();
        this.hasActiveTasks = tasksList.length > 0;
      } catch (error) {
        if (error.status === 401) {
          this.stopPolling();
          const { useUserStore } = await import("./user.js");
          useUserStore().logout();
          return;
        }
        console.error("Failed to check active tasks:", error);
      }
    },
    startPolling() {
      if (pollingIntervalId !== null) {
        return;
      }
      this.checkTasks();
      pollingIntervalId = setInterval(
        () => this.checkTasks(),
        POLLING_INTERVAL_MS,
      );
    },
    stopPolling() {
      if (pollingIntervalId !== null) {
        clearInterval(pollingIntervalId);
        pollingIntervalId = null;
      }
      this.hasActiveTasks = false;
    },
  },
});
